<template>
  <div class="main-page">
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="col-12 md:col-12 sm:col-12 comp-grid">
            <div>
              <form
                ref="observer"
                tag="form"
                @submit.prevent="startSaveRecord()"
                @reset="resetForm"
              >
                <div>
                  <table class="p-datatable-table" style="width: 100%">
                    <tbody>
                      <tr
                        v-for="(formData, row) in arrFormData"
                        :key="row"
                        class="input-row"
                      >
                        <div class="card nice-shadow-5">
                          <div class="grid">
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                {{ $t("year") }} *
                              </div>

                              <div class="">
                                <!-- <div class="field mb-0"> -->
                                <Dropdown
                                  class="w-full"
                                  ref="ctrlsitting_year"
                                  v-model="formData.sitting_year"
                                  :options="
                                    $utils.years(
                                      formData.sitting_year,
                                      null,
                                      dob_year
                                    )
                                  "
                                  :label="$t('year')"
                                  :placeholder="$t('select')"
                                  :class="getErrorClass(row, 'sitting_year')"
                                >
                                </Dropdown>
                                <small class="text-xs text-primary mx-1">{{
                                  $t(
                                    "kindly_reload_page_if_dropdown_not_showing"
                                  )
                                }}</small>
                                <!-- </div> -->
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                {{ $t("month") }} *
                              </div>

                              <div class="">
                                <!-- <div class="field mb-0"> -->
                                <Dropdown
                                  :class="getErrorClass(row, 'sitting_month')"
                                  class="w-full"
                                  optionLabel="label"
                                  optionValue="value"
                                  ref="ctrlsitting_month"
                                  v-model="formData.sitting_month"
                                  :options="$menus.exam_sitting_monthItems"
                                  :label="$t('month')"
                                  :placeholder="$t('select')"
                                >
                                </Dropdown>
                                <!-- </div> -->
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                {{ $t("exams_type") }} *
                              </div>

                              <div class="">
                                <!-- <div class="field mb-0"> -->
                                <Dropdown
                                  class="w-full"
                                  :class="getErrorClass(row, 'exams_type')"
                                  optionLabel="label"
                                  optionValue="value"
                                  ref="ctrlexams_type"
                                  v-model="formData.exams_type"
                                  :options="$menus.shs_qualificationItems"
                                  :label="$t('exams_type')"
                                  :placeholder="$t('select')"
                                >
                                  <template #option="slotProps">
                                    <div class="flex align-items-center">
                                      <div>
                                        <div>
                                          {{ slotProps.option.label }}
                                        </div>
                                        <div
                                          v-if="slotProps.option.description"
                                          class="text-sm text-500"
                                        >
                                          {{ slotProps.option.description }}
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </Dropdown>
                                <!-- </div> -->
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                {{ $t("index_number") }} *
                              </div>

                              <div class="">
                                <!-- <div class="field mb-0"> -->
                                <InputText
                                  ref="ctrlindex_number"
                                  v-model.trim="formData.index_number"
                                  :label="$t('index_number')"
                                  type="text"
                                  :placeholder="$t('index_number')"
                                  class="w-full"
                                  :class="getErrorClass(row, 'index_number')"
                                >
                                </InputText>
                                <!-- </div> -->
                              </div>
                            </div>
                          </div>
                          <!-- <div
                            v-if="formData.verified_results"
                            class="grid mt-2"
                          >
                            <div class="col-12">
                              <div
                                class="card bg-green-100 nice-shadow-6 mb-0 pt-3 pb-1"
                              >
                                <div class="mb-2">
                                  <div class="grid">
                                    <div class="col-fixed">
                                      <img
                                        style="
                                          width: 50px;
                                          height: 50px;
                                          border-radius: 50%;
                                          overflow: hidden;
                                        "
                                        :src="
                                          $utils.setImgUrl($UserPhoto, 'medium')
                                        "
                                      />
                                    </div>
                                    <div class="col">
                                      <div class="text-md text-primary mb-1">
                                        {{ formData.verified_results.cname }}
                                      </div>
                                      <div class="text-sm text-gray-500">
                                        {{ $t("day_of_birth") }}:
                                        {{ formData.verified_results.dob }}
                                      </div>
                                      <div class="text-sm text-gray-500">
                                        {{ $t("exams_type") }}:
                                        {{ formData.verified_results.examtype }}
                                      </div>
                                      <div class="text-sm text-gray-500">
                                        {{ $t("status") }}: VERIFIED
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div class="text-yellow-600 text-sm mt-3">
                              {{ $t("click_to_verify_your_sitting_details") }}
                            </div>
                          </div> -->
                        </div>
                        <th v-if="!formData.verified_results">
                          <Button
                            class="p-button-text p-button-danger p-button-rounded p-button-sm"
                            v-if="arrFormData.length > minRowCount"
                            @click="removeFormRow(row)"
                            icon="pi pi-times"
                          />
                        </th>
                      </tr>
                    </tbody>
                    <tfoot>
                      <!-- <Divider v-if="!saving"></Divider> -->
                      <!-- <ProgressBar
                        v-if="saving"
                        mode="indeterminate"
                        class="mb-3 mt-3"
                        style="height: 0.2em"
                      /> -->
                      <tr>
                        <td colspan="100" class="text-left">
                          <div class="flex justify-content-between mb-3">
                            <!-- <div class="">
                              <Button
                                :label="$t('verify_results')"
                                class="p-button-outlined p-button-success p-button-rounded p-button-sm"
                                :loading="saving"
                                @click="verifyExamsResults"
                              />
                            </div> -->
                            <div class="">
                              <Button
                                v-if="arrFormData.length < maxRowCount"
                                @click="addFormRow()"
                                icon="pi pi-plus"
                                :label="$t('add_more')"
                                class="p-button-text p-button-success p-button-sm p-0 mt-3"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </form>
              <slot :submit="submit" :saving="saving"></slot>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { PageMixin } from "../../mixins/page.js";
import { AddPageMixin } from "../../mixins/addpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { ApiService } from "../../services/api";
import { helpers, required } from "@vuelidate/validators";
import { i18n } from "../../services/i18n.js";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "examsittingsPage",
  components: {},
  mixins: [PageMixin, AddPageMixin],
  props: {
    pageName: {
      type: String,
      default: "exam_sittings",
    },
    maxRowCount: {
      type: Number,
      default: 4,
    },
    minRowCount: {
      type: Number,
      default: 1,
    },
    sittings: { type: String, default: "[]" },
    dobYear: {
      type: Number,
      default: 1950,
    },
  },
  data() {
    return {
      arrFormData: [
        {
          sitting_year: "",
          sitting_month: "",
          exams_type: "",
          index_number: "",
          confirm_index_number: "",
          verified_results: "",
        },
      ],
      dob_year: 1950,
    };
  },
  validations() {
    let arrFormData = {
      $each: helpers.forEach({
        sitting_year: { required },
        sitting_month: { required },
        exams_type: { required },
        index_number: { required },
        confirm_index_number: {},
        verified_results: {},
      }),
    };
    return { arrFormData };
  },
  computed: {
    pageTitle: {
      get: function () {
        return this.$t("add_new_exam_sittings");
      },
    },
  },
  methods: {
    ...mapActions("exam_sittings", ["saveRecord"]),
    async startSaveRecord() {
      this.submitted = true;
      // const isFormValid = await this.v$.$validate();
      // if (!isFormValid) {
      //   let errors = this.v$.arrFormData.$each.$response.$errors;
      //   this.flashMsg(
      //     this.$t("please_complete_the_form"),
      //     this.$t("form_is_invalid"),
      //     "error"
      //   );
      //   return;
      // }
      this.saving = true;
      let payload = this.normalizedFormData();
      let url = this.apiUrl;
      let data = { url, payload };
      this.saveRecord(data).then(
        (response) => {
          this.saving = false;
          this.resetForm();
          this.closeDialogs(); // close page dialog that if opened
          this.flashMsg(this.msgAfterSave);
          this.$emit("submitted", this.record);
          if (this.redirect) this.navigateTo(`/exam_sittings`);
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    getExamsSittings() {
      if (this.sittings) {
        this.arrFormData = JSON.parse(this.sittings);
      }
      this.dob_year = this.dobYear;
    },
    addFormRow() {
      let newFormData = {
        sitting_year: "",
        sitting_month: "",
        exams_type: "",
        index_number: "",
        confirm_index_number: "",
        verified_results: "",
      };
      this.arrFormData.push(newFormData);
    },
    removeFormRow(index) {
      this.arrFormData.splice(index, 1);
    },
    resetForm() {
      this.arrFormData = [
        {
          sitting_year: "",
          sitting_month: "",
          exams_type: "",
          index_number: "",
          confirm_index_number: "",
          verified_results: "",
        },
      ];
      this.updateFormData();
    },
    getErrorClass(row, field) {
      let errors = this.v$.arrFormData.$each.$response.$errors[row][field];
      return { "p-invalid": errors.length && this.submitted };
    },
    async verifyExamsResults() {
      for (const data of this.arrFormData) {
        data.verified_results = "";
      }
      const isFormValid = await this.v$.$validate();
      if (!isFormValid) {
        let errors = this.v$.arrFormData.$each.$response.$errors;
        this.flashMsg(
          this.$t("please_complete_the_form"),
          this.$t("form_is_invalid"),
          "error"
        );
        return;
      }
      this.saving = true;
      let payload = this.normalizedFormData();
      let url = `applicants/verifyresults`;
      ApiService.post(url, payload)
        .then((resp) => {
          this.saving = false;
          let records = resp.data;
          this.setVerifiedResults(records);
        })
        .catch((err) => {
          this.saving = false;
          this.showPageRequestError(err);
        });
    },
    setVerifiedResults(records) {
      records.map((value, index, array) => {
        this.arrFormData[index].verified_results = "";
        let exams = this.arrFormData.find(
          (e) => e.index_number == value.cindex
        );
        if (exams) {
          this.arrFormData[index].verified_results = value;
        }
      });
    },
  },
  watch: {},
  async mounted() {
    this.getExamsSittings();
  },
  async created() {},
};
</script>
<style scoped></style>
